import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import backk from './images/backk.png'; // Make sure the path is correct for your project

const Delete = () => {
  const [personName, setPersonName] = useState('');
  const [loading, setLoading] = useState(true);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const userEmail = sessionStorage.getItem('userEmail'); // Get userEmail from session storage
  const navigate = useNavigate(); // Initialize navigate for back functionality

  // useEffect to fetch the person name
  useEffect(() => {
    const fetchPersonName = async () => {
      try {
        console.log(`Fetching person name for email: ${userEmail}`);
        const response = await fetch(`/GetPersonNameAPI?userEmail=${userEmail}`);
        console.log(`Response status: ${response.status}`);

        if (response.ok) {
          const data = await response.json();
          console.log(`Fetched person name: ${data.personName}`);
          setPersonName(data.personName);
        } else if (response.status === 404) {
          alert('Person name not found for the given email.');
        } else {
          alert('Failed to fetch person name.');
        }
      } catch (error) {
        console.error('Error fetching person name:', error);
        alert('An error occurred while fetching person name.');
      } finally {
        setLoading(false);
      }
    };

    if (userEmail) {
      fetchPersonName();
    } else {
      alert('No user email found in session.');
      setLoading(false);
    }
  }, [userEmail]);

  const handleBackClick = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleConfirmClick = () => {
    setShowDeleteConfirm(true); // Show confirmation popup
  };

  const handleDeleteRecord = async () => {
    const queries = {
      query_f: "DELETE FROM RosaF WHERE Gmail = %s AND PersonName = %s",
      query_open: "DELETE FROM RosaF WHERE Gmail = %s AND PersonName = %s"
    };

    try {
      const response = await fetch('/DeleteRecordAPI', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userEmail,
          personName,
          queries, // Pass SQL queries from frontend to backend
        }),
      });

      if (response.ok) {
        setShowDeleteConfirm(false); // Close confirmation modal
        alert('Record Deleted Successfully!');
      } else {
        alert('Deletion failed, please try again.');
      }
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('An error occurred while deleting the record.');
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false); // Close confirmation popup
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        height: '100vh',
        background: 'linear-gradient(90deg, #fff7ad, #ffa9f9)', // Background gradient
      }}
    >
      <div style={{ marginTop: '20px' }}>
        <h2 style={{ color: '#E11584' }}>Delete Screen</h2>
        <p style={{ color: '#E11584' }}>Signed in as: {userEmail}</p>
        <p style={{ color: '#E11584' }}>PersonName: {personName}</p>

        <h3>Are you sure you want to delete your records?</h3>
        <button
          onClick={handleConfirmClick}
          style={{
            backgroundColor: '#E11584',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop: '10px',
          }}
        >
          Confirm
        </button>
      </div>

      {/* Confirmation popup */}
      {showDeleteConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '10px',
              textAlign: 'center',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
            }}
          >
            <h3>Delete Record?</h3>
            <button
              onClick={handleDeleteRecord}
              style={{
                backgroundColor: '#E11584',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '10px',
                marginRight: '10px',
              }}
            >
              Yes
            </button>
            <button
              onClick={handleCancelDelete}
              style={{
                backgroundColor: '#E11584',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '10px',
              }}
            >
              No
            </button>
          </div>
        </div>
      )}

      {/* Back button at the bottom */}
      <div style={{ marginTop: 'auto' }}> {/* 'auto' to push it to the bottom */}
        <button onClick={handleBackClick} style={{ marginTop: '20px' }}>
          <img src={backk} width="40" height="40" alt="Back" />
        </button>
      </div>
    </div>
  );
};

export default Delete;
